import styled from 'styled-components';
import Button from '../../../../_ui/_v2/components/Button';

const PlusButton = styled(Button)`
  width: 100%;
  background-color: ${props => props.theme.colors.lightGrey};
`;

export default PlusButton;